module.exports = __webpack_public_path__ + "img/imgnew-5.80f09958.jpg";